import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {DealActivityType} from 'yougile-model'
import {TabSwitcherItem, TwTabSwitcherContainer} from './tab-switcher-item'

interface Props {
  onChange: (active: DealActivityType) => void
}

export const DealHistorySwitcher = (props: Props) => {
  const {onChange} = props
  const [active, setActive] = useState<DealActivityType>('deal')

  return (
    <TwTabSwitcherContainer>
      <TabSwitcherItem
        icon="IconCustomBolt"
        title={Lang.msg.crm.rightPanel.dealHistory.deal}
        active={active === 'deal'}
        onClick={() => {
          setActive('deal')
          onChange('deal')
        }}
      />
      <TabSwitcherItem
        icon="IconCustomDealComment"
        title={Lang.msg.crm.rightPanel.dealHistory.note}
        active={active === 'note'}
        onClick={() => {
          setActive('note')
          onChange('note')
        }}
      />
    </TwTabSwitcherContainer>
  )
}
